interface ServiceMainTitle {
  category: string
  title: string
  sub_title: string
  sub_title2: string
  text: string
  imgSrc: string
}

export const serviceMainTitle: ServiceMainTitle = {
  category: 'デジタルイノベーションサポート',
  title: '組織開発・人材育成',
  sub_title: '',
  sub_title2: '',
  text: 'イノベーション思考を実践することでDXマインドを形成するワークショップ「ヒューマンイノベーションプログラム」を提供します。',
  //imgSrc: '/images/img/service/img_service_inovation.jpg',
  imgSrc: '',
}
